"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocaleSchema = void 0;
exports.LocaleSchema = {
    "$id": "https://www.redbull.com/schemas/locales.schema.json",
    "$schema": "https://json-schema.org/draft/2020-12/schema",
    "title": "Locale",
    "description": "Stores a locale",
    "type": "object",
    "required": [
        "type",
        "id",
        "attributes",
        "relationships"
    ],
    "properties": {
        "type": {
            "enum": [
                "rrn:locales"
            ],
            "type": "string"
        },
        "id": {
            "type": "string",
            "pattern": "^rrn:locales:[a-z]{2}-[A-Z]{2,3}$"
        },
        "attributes": {
            "additionalProperties": false,
            "type": "object",
            "required": [
                "baseWebURL",
                "language",
                "localeMixingStrategy",
                "region"
            ],
            "properties": {
                "baseWebURL": {
                    "description": "The primary web URL for this locale.",
                    "type": "string"
                },
                "language": {
                    "description": "The language of the locale",
                    "type": "string"
                },
                "localeMixingStrategy": {
                    "description": "The locales from which content is fetched. First element is primary locale, remaining locales are used to fill up feed.",
                    "type": "array",
                    "items": {
                        "type": "string"
                    },
                    "minItems": 1
                },
                "region": {
                    "description": "The ISO region code of the locale.",
                    "type": "string"
                }
            }
        },
        "relationships": {
            "additionalProperties": false,
            "type": "object"
        },
        "links": {
            "type": "object",
            "additionalProperties": {
                "type": [
                    "object",
                    "string"
                ],
                "description": "A link **MUST** be represented as either: a string containing the link's URL or a link object.",
                "oneOf": [
                    {
                        "description": "A string containing the link's URL.",
                        "type": "string",
                        "format": "uri-reference"
                    },
                    {
                        "type": "object",
                        "required": [
                            "href"
                        ],
                        "properties": {
                            "href": {
                                "description": "A string containing the link's URL.",
                                "type": "string",
                                "format": "uri-reference"
                            },
                            "meta": {
                                "description": "Non-standard meta-information that can not be represented as an attribute or relationship.",
                                "type": "object",
                                "additionalProperties": true
                            }
                        }
                    }
                ]
            }
        },
        "meta": {
            "additionalProperties": true,
            "type": "object"
        }
    }
};
//# sourceMappingURL=data:application/json;base64,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